const ModalFooter = (props) =>{
    return(
        <div className="modal-footer border-0">
            {props.children}
        </div>
    )
}
export default ModalFooter